import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app, auth, RecaptchaVerifier, signInWithPhoneNumber } from './firebase';
import './App.css';

const tabs = [
  {
    id: 'home',
    label: 'Home',
    icon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5.5v-5.5h-3V21H5a1 1 0 0 1-1-1Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 'simulate',
    label: 'Simular',
    icon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M4 12a8 8 0 0 1 14.3-4.9l1.7 1.9M20 12a8 8 0 0 1-14.3 4.9L4 15.1"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 10.5h3.1a1.9 1.9 0 0 1 0 3.8H10M12 15.3v1.2M12 7.5v1.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={0.85}
        />
      </svg>
    ),
  },
  {
    id: 'requests',
    label: 'Solicitações',
    icon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M5.5 5h9l4 4.2V19a.9.9 0 0 1-.9.9H5.5A1.5 1.5 0 0 1 4 18.4V6.5A1.5 1.5 0 0 1 5.5 5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 12.2h8M8 15.2h5.5M14.5 5v3.7h4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={0.85}
        />
      </svg>
    ),
  },
  {
    id: 'faq',
    label: 'FAQ',
    icon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle
          cx="12"
          cy="12"
          r="8"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
        />
        <path
          d="M9.5 10.1a2.5 2.5 0 1 1 3.5 2.2c-.6.3-1 .8-1 1.4v.3M12 16.8h.01"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={0.85}
        />
      </svg>
    ),
  },
  {
    id: 'support',
    label: 'Atendimento',
    icon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M6 9.4a6 6 0 0 1 12 0v2.7a3.9 3.9 0 0 1-3.9 3.9H13l-2.4 2.6c-.3.3-.9.1-.9-.3v-2.3H8.9A3 3 0 0 1 6 12.8Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const monthlyRate = 0.045;
const terms = [48, 60, 84, 96];

const formatCurrency = (value) =>
  value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 2,
  });

const formatDateTimeBR = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

const normalizeWhatsapp = (value) => {
  const digits = (value || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.startsWith('55') ? digits : `55${digits}`;
};

const buildWhatsappLink = (phone, label) => {
  const phoneDigits = normalizeWhatsapp(phone);
  if (!phoneDigits) return '';
  const message = label
  ? `Olá! Tudo bem? Cheguei até você pelo seu link de auto contratação ${label}`
  : 'Olá! Tudo bem? Cheguei até você pelo seu link de auto contratação';

  return `https://wa.me/${phoneDigits}?text=${encodeURIComponent(message)}`;
};

 function getGeo() {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve({ ok: false, error: "Geolocalização não suportada" });
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) =>
          resolve({
            ok: true,
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          }),
        (err) => resolve({ ok: false, error: err.message }),
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    });
  }

  // Escuta pedidos de QUALQUER iframe (dinâmico)
  window.addEventListener("message", async (event) => {
    const data = event.data || {};

    if (data.type !== "TB_GET_GEO") return;

    const requestId = data.requestId;

    const geo = await getGeo();

    // RESPONDE DIRETAMENTE para quem pediu (iframe correto)
    event.source.postMessage(
      { type: "TB_GEO_RESULT", requestId, geo },
      event.origin
    );
  });
function Simulator({ phoneUser, correspondent, haccess, onOpenContract }) {
  const [mode, setMode] = useState('amount');
  const [selectedTerm, setSelectedTerm] = useState(48);
  const [amount, setAmount] = useState(15000);
  const [installment, setInstallment] = useState(650);

  const installmentFromAmount = (principal, term) => {
    const factor = (monthlyRate * principal) / (1 - Math.pow(1 + monthlyRate, -term));
    return factor;
  };

  const principalFromInstallment = (value, term) => {
    const principal = value * ((1 - Math.pow(1 + monthlyRate, -term)) / monthlyRate);
    return principal;
  };

  const results = useMemo(() => {
    if (mode === 'amount') {
      return terms.map((term) => {
        const installmentValue = installmentFromAmount(amount, term);
        const total = installmentValue * term;
        return {
          term,
          installment: installmentValue,
          total,
          interest: total - amount,
        };
      });
    }

    return terms.map((term) => {
      const principal = principalFromInstallment(installment, term);
      const total = installment * term;
      return {
        term,
        installment,
        total,
        principal,
        interest: total - principal,
      };
    });
  }, [amount, installment, mode]);

  const highlight = results.find((item) => item.term === selectedTerm) || results[0];

  return (
    <div className="section-card">
      <div className="section-header">
        <div>
          <p className="eyebrow">Simule em segundos</p>
          <h2>Qual e o melhor plano para você?</h2>
        </div>
        <div className="mode-toggle">
          <button
            type="button"
            className={mode === 'amount' ? 'active' : ''}
            onClick={() => setMode('amount')}
          >
            Valor solicitado
          </button>
          <button
            type="button"
            className={mode === 'installment' ? 'active' : ''}
            onClick={() => setMode('installment')}
          >
            Valor da parcela
          </button>
        </div>
      </div>

      {mode === 'amount' ? (
        <div className="field">
          <label htmlFor="amount">Quanto deseja solicitar?</label>
          <div className="field-input">
            <input
              id="amount"
              type="range"
              min="1000"
              max="60000"
              step="500"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />
            <div className="input-value">{formatCurrency(amount)}</div>
          </div>
        </div>
      ) : (
        <div className="field">
          <label htmlFor="installment">Quanto cabe no seu bolso?</label>
          <div className="field-input">
            <input
              id="installment"
              type="range"
              min="200"
              max="3000"
              step="50"
              value={installment}
              onChange={(e) => setInstallment(Number(e.target.value))}
            />
            <div className="input-value">{formatCurrency(installment)}</div>
          </div>
        </div>
      )}

      <div className="term-list">
        {results.map((item) => (
          <button
            key={item.term}
            type="button"
            className={`term-card ${selectedTerm === item.term ? 'active' : ''}`}
            onClick={() => setSelectedTerm(item.term)}
          >
            <div className="term-label">{item.term} meses</div>
            <div className="term-value">{formatCurrency(item.installment)}</div>
            <p className="term-sub">
              {mode === 'amount'
                ? `Total: ${formatCurrency(item.total)}`
                : `Recebe: ${formatCurrency(item.principal)}`}
            </p>
          </button>
        ))}
      </div>

      <div className="summary-card">
        <div>
          <p className="eyebrow">Detalhes do plano escolhido</p>
          <h3>{highlight.term} meses com juros de 4,5% a.m.</h3>
          <p className="muted">
            Valores estimados. A proposta final depende da análise de crédito e dados
            cadastrais.
          </p>
        </div>
        <div className="summary-grid">
          <div>
            <p className="muted">{mode === 'amount' ? 'Parcela estimada' : 'Parcela'}</p>
            <strong>{formatCurrency(highlight.installment)}</strong>
          </div>
          <div>
            <p className="muted">
              {mode === 'amount' ? 'Total a pagar' : 'Valor liberado'}
            </p>
            <strong>
              {mode === 'amount'
                ? formatCurrency(highlight.total)
                : formatCurrency(highlight.principal)}
            </strong>
          </div>
          <div>
            <p className="muted">Juros aproximados</p>
            <strong>{formatCurrency(highlight.interest)}</strong>
          </div>
        </div>
        <div className="summary-actions">
          <button type="button" className="cta-btn" onClick={() => onOpenContract?.()}>
            Contrate Agora
          </button>
        </div>
      </div>
    </div>
  );
}

function Requests({ items: initialItems }) {
  const [externalRequests, setExternalRequests] = useState(initialItems || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window.__USER_PROFILE?.requests) {
      setExternalRequests(window.__USER_PROFILE.requests);
    }
  }, []);

  useEffect(() => {
    if (initialItems && initialItems.length) {
      setExternalRequests(initialItems);
    }
  }, [initialItems]);

  const fallback = [
    {
      id: 'mock-1',
      type: 'Credito consignado',
      status: 'Aprovado',
      amount: 32000,
      term: 72,
      createdAt: 'Hoje, 10:12',
    },
    {
      id: 'mock-2',
      type: 'Portabilidade de salario',
      status: 'Em analise',
      amount: 18500,
      term: 36,
      createdAt: 'Ontem, 18:40',
    },
    {
      id: 'mock-3',
      type: 'Cartao consignado',
      status: 'Documentacao pendente',
      amount: 5000,
      term: 24,
      createdAt: '29/11, 09:27',
    },
  ];

  const items = externalRequests.length ? externalRequests : fallback;

  return (
    <div className="section-card">
      <div className="section-header">
        <div>
          <p className="eyebrow">Acompanhe suas solicitações</p>
          <h2>Minhas solicitações</h2>
        </div>
        <button
          type="button"
          className="ghost-btn"
          onClick={() => {
            const event = new CustomEvent('refresh-requests');
            window.dispatchEvent(event);
            setLoading(true);
            setTimeout(() => setLoading(false), 800);
          }}
        >
          {loading ? 'Atualizando...' : 'Atualizar status'}
        </button>
      </div>

      {externalRequests.length === 0 ? (
        <div className="empty-state">
          <p className="eyebrow">Sem solicitações ainda</p>
          <h3>Que tal simular e criar sua primeira solicitação?</h3>
          <p className="muted">
            Faça uma simulação e acompanhe tudo aqui. Assim que houver solicitações, você verá
            os status atualizados.
          </p>
          <button type="button" className="connect-btn" onClick={() => window.dispatchEvent(new CustomEvent('go-simulate'))}>
            Simular agora
          </button>
        </div>
      ) : (
        <div className="timeline">
          {items.map((item) => {
            const docLinks = [
              {
                key: 'url_contrato_assinado',
                label: 'Contrato',
                icon: (
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M7 4h7.6L17 6.6V20a.9.9 0 0 1-.9.9H7.9A.9.9 0 0 1 7 20Z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.6 4v3.1H17M9 11h6M9 15h4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      opacity={0.85}
                    />
                  </svg>
                ),
              },
              {
                key: 'url_propostaseguro_assinado',
                label: 'Seguro',
                icon: (
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M12 4.5 6.5 7v5.4a7.8 7.8 0 0 0 5.1 7l.4.1.4-.1a7.8 7.8 0 0 0 5.1-7V7Z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="m9.5 12 1.7 1.6 3.3-3.5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      opacity={0.85}
                    />
                  </svg>
                ),
              },
              {
                key: 'url_ccb_assinado',
                label: 'CCB',
                icon: (
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M6.5 5h9.3a1.2 1.2 0 0 1 1.2 1.2v11.1a1.2 1.2 0 0 1-1.2 1.2H6.5A1.2 1.2 0 0 1 5.3 17V6.2A1.2 1.2 0 0 1 6.5 5Z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 9.5h4.6M9 12h3.2M9 14.5h5.2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      opacity={0.85}
                    />
                    <path
                      d="m7.8 5 1-2h6.5l1 2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      opacity={0.85}
                    />
                  </svg>
                ),
              },
            ].filter(({ key }) => Boolean(item[key]));

            const displayedDate = formatDateTimeBR(item.createdAt || item.date);
            const whatsappLink = buildWhatsappLink(
              item.whatsappcorrespondente,
              item.numeroProposta ? `a proposta ${item.numeroProposta}` : item.type
            );
            const proposalNumber = item.numeroProposta || item.id || '-';
            const correspondentName = item.correspondente || '-';
            const correspondentPhone = item.whatsappcorrespondente;

            return (
              <div className="timeline-item" key={item.id || item.title}>
                <div className="timeline-icon" />
                <div className="timeline-content">
                  <div className="timeline-row">
                    <h3>{item.title || item.type}</h3>
                    <span
                      className={`status-pill status-${(item.status || '').replace(/\s+/g, '')}`}
                    >
                      {item.status}
                    </span>
                  </div>
                  <p className="muted">{displayedDate}</p>
                  <div className="timeline-meta">
                    <div>
                      <p className="muted">Numero da proposta</p>
                      <strong>{proposalNumber}</strong>
                    </div>
                    <div>
                      <p className="muted">Correspondente</p>
                      <strong>{correspondentName}</strong>
                      {/* {correspondentPhone && (
                        <span className="muted phone-hint">{correspondentPhone}</span>
                      )} */}
                    </div>
                    {whatsappLink && (
                      <a
                        className="whatsapp-btn"
                        href={whatsappLink}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Conversar com o correspondente no WhatsApp"
                      >
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path
                            d="M12 3.4A8.6 8.6 0 0 0 4.8 17L4 20l3.1-.8A8.6 8.6 0 1 0 12 3.4Z"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9.8 9.2c0 .5.2 1 .5 1.5l-.7 1.2a6.1 6.1 0 0 0 3 1.8l.9-.9c.4.3.9.5 1.4.5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            opacity={0.9}
                          />
                        </svg>
                        {correspondentPhone}
                      </a>
                    )}
                  </div>
                  <div className="timeline-grid">
                    <div>
                      <p className="muted">Valor liberado</p>
                      <strong>{formatCurrency(item.amount || 0)}</strong>
                    </div>
                    <div>
                      <p className="muted">Prazo</p>
                      <strong>{item.term} meses</strong>
                    </div>
                  </div>
                  {docLinks.length > 0 && (
                    <div className="doc-links">
                      <p className="muted">Documentos assinados</p>
                      <div className="doc-link-row">
                        {docLinks.map(({ key, label, icon }) => (
                          <a
                            key={key}
                            className="doc-link-btn"
                            href={item[key]}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={`Abrir ${label}`}
                          >
                            {icon}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function Faq() {
  const faqs = [
   {
      q: 'Quem pode solicitar o consignado WebCash?',
      a: 'Servidores públicos, aposentados e pensionistas podem contratar, sujeito à margem consignável e à análise.',
    },
    {
      q: 'Quanto tempo leva para a liberação do crédito?',
      a: 'Na maioria dos casos, a pré-aprovação sai no mesmo dia. A liberação acontece após a conferência de documentos e a assinatura digital.',
    },
    {
      q: 'Posso antecipar parcelas?',
      a: 'Sim. A antecipação reduz juros futuros. Basta solicitar pelo atendimento e calculamos o desconto.',
    },
    {
      q: 'Meus dados estão seguros?',
      a: 'Usamos criptografia, autenticação e seguimos as diretrizes do BACEN para manter seu cadastro protegido.',
    }

  ];

  return (
    <div className="section-card">
      <div className="section-header">
        <div>
          <p className="eyebrow">Dúvidas frequentes</p>
          <h2>FAQ e ajuda rápida</h2>
        </div>
        {/* <span className="muted">Atualizado semanalmente</span> */}
      </div>
      <div className="faq-grid">
        {faqs.map((item) => (
          <div className="faq-card" key={item.q}>
            <h3>{item.q}</h3>
            <p className="muted">{item.a}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

function Support({ correspondent, phoneUser, haccess, onOpenContract }) {
  const [botError, setBotError] = useState(false);
  const [botReady, setBotReady] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [botLoaded, setBotLoaded] = useState(false);
  const containerId = 'typebot-container';
  const chatUrl = useMemo(() => {
    const phone = encodeURIComponent(phoneUser || '');
    const host = encodeURIComponent(window?.location?.host || '');
    const idCorr = encodeURIComponent(correspondent?.consultor.id || '');
    const haccessParam = encodeURIComponent(haccess || '');
    return `https://kira.viabillize.com.br/chat-pwaconsig?phone=${phone}&sistema=${host}&idcorrespondente=${idCorr}&haccess=${haccessParam}`;
  }, [phoneUser, correspondent, haccess]);

  useEffect(() => {
    const ensureScript = () => {
      if (window.Typebot?.initStandard) {
        setBotReady(true);
        return;
      }

      let script = document.getElementById('typebot-module');
      const handleLoad = () => {
        setBotReady(true);
      };
      const handleError = (error) => {
        console.error('Erro ao carregar o Typebot', error);
        setBotError(true);
      };

      if (!script) {
        script = document.createElement('script');
        script.id = 'typebot-module';
        script.type = 'module';
        script.innerHTML = `
          import Typebot from 'https://cdn.jsdelivr.net/npm/@typebot.io/js@0.3.27/dist/web.js';
          window.Typebot = Typebot;
        `;
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
        document.body.appendChild(script);
      } else {
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
      }

      return () => {
        script?.removeEventListener('load', handleLoad);
        script?.removeEventListener('error', handleError);
      };
    };

    const cleanup = ensureScript();
    return cleanup;
  }, []);

  useEffect(() => {
    if (!overlayOpen || !botReady || botError) return;
    const container = document.getElementById(containerId);
    if (!container || container.dataset.typebotLoaded) return;
    if (!window.Typebot?.initStandard) return;
    try {
      window.Typebot.initStandard({
        typebot: 'siconsig-acesso',
        apiHost: 'https://kira.viabillize.com.br',
        element: `#${containerId}`,
        url: chatUrl,
      });
      container.dataset.typebotLoaded = 'true';
      setBotLoaded(true);
    } catch (error) {
      console.error('Erro ao iniciar o Typebot', error);
      setBotError(true);
    }
  }, [overlayOpen, botReady, botError, chatUrl]);

  useEffect(() => {
    if (!overlayOpen || botError || botLoaded) return;
    const timer = setTimeout(() => {
      const container = document.getElementById(containerId);
      if (container && container.dataset.typebotLoaded) {
        setBotLoaded(true);
        return;
      }
      // Se continuar vazio, cai para o fallback iframe
      setBotError(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [overlayOpen, botError, botLoaded]);

  const whatsappLink = buildWhatsappLink(
    correspondent?.consultor.whatsapp,
    correspondent?.consultor.id ? ` ${correspondent?.consultor.id} do correspondente ${correspondent.fantasia}` : 'o correspondente'
  );

  const address = correspondent?.endereco;
  const addressLine = address
    ? [address.logradouro, address.complemento].filter(Boolean).join(', ')
    : '';
  const addressCity = address
    ? [address.bairro, address.municipio, address.uf].filter(Boolean).join(' - ')
    : '';
  const isBotLoading = overlayOpen && !botError && !botLoaded;

  return (
    <div className="section-card">
      <div className="section-header">
        <div>
          <p className="eyebrow">Fale com a gente</p>
          <h2>Atendimento imediato</h2>
        </div>
        <span className="muted">Humanizado e 100% digital</span>
      </div>
      <div className="support-grid">
        <div className="correspondent-card">
          <div className="correspondent-header">
            <div className="avatar-circle">
              {correspondent?.consultor.foto ? (
                <span
                  className="avatar-image"
                  style={{ backgroundImage: `url(${correspondent.consultor.foto})` }}
                  aria-label="Foto do Consultor"
                />
              ) : (
                <span className="avatar-initial">
                  {(correspondent?.fantasia || 'C')[0]?.toUpperCase()}
                </span>
              )}
            </div>
            <div>
              <p className="eyebrow">{correspondent?.consultor.titulo || 'Consultor'}</p>
              <h3>{correspondent?.consultor.nome || ' '}</h3>
              <p className="eyebrow">Correspondente</p>
              <h3>{correspondent?.fantasia || ' '}</h3>
              {correspondent?.cnpj && <p className="muted">CNPJ {correspondent.cnpj}</p>}
              
              {/* {correspondent?.cnpj && <p className="muted">CNPJ {correspondent.cnpj}</p>} */}
            </div>
          </div>
          {/* {addressLine && <p className="muted">{addressLine}</p>}
          {addressCity && <p className="muted">{addressCity}</p>} */}
          <div className="support-actions">
            {whatsappLink && (
              <a
                className="whatsapp-btn"
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                aria-label="Conversar com o correspondente no WhatsApp"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M12 3.4A8.6 8.6 0 0 0 4.8 17L4 20l3.1-.8A8.6 8.6 0 1 0 12 3.4Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.8 9.2c0 .5.2 1 .5 1.5l-.7 1.2a6.1 6.1 0 0 0 3 1.8l.9-.9c.4.3.9.5 1.4.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity={0.9}
                  />
                </svg>
                {correspondent.consultor.whatsapp}
              </a>
            )}
            <button
              type="button"
              className="chat-btn"
              onClick={() => setOverlayOpen(true)}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M6 9.4a6 6 0 0 1 12 0v2.7a3.9 3.9 0 0 1-3.9 3.9H13l-2.4 2.6c-.3.3-.9.1-.9-.3v-2.3H8.9A3 3 0 0 1 6 12.8Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              ATENDIMENTO ONLINE
            </button>
            <button
              type="button"
              className="chat-btn"
              onClick={() => onOpenContract?.()}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M5.5 5h9l4 4.2V19a.9.9 0 0 1-.9.9H5.5A1.5 1.5 0 0 1 4 18.4V6.5A1.5 1.5 0 0 1 5.5 5Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 12.2h8M8 15.2h5.5M14.5 5v3.7h4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  opacity={0.85}
                />
              </svg>
              CONTRATE AGORA
            </button>
          </div>
        </div>
        <div className="support-note">
          <p className="muted">
           Preferimos resolver tudo on-line, mas, se precisar, estamos a um clique no WhatsApp ou no chat.
           Sua experiência continua segura e humanizada.
          </p>
        </div>
      </div>

      {typeof document !== 'undefined' &&
        createPortal(
          <div
            className={`typebot-overlay ${overlayOpen ? 'open' : 'hidden'}`}
            role="dialog"
            aria-modal="true"
            aria-hidden={!overlayOpen}
          >
            <div className="typebot-modal">
              <div className="typebot-bar">
                <div>
                  <p className="eyebrow">Chat</p>
                  <strong>Atendimento em tempo real</strong>
                </div>
                <button
                  type="button"
                  className="close-btn"
                  onClick={() => setOverlayOpen(false)}
                >
                  Fechar
                </button>
              </div>
              <div className="typebot-frame">
                {botError ? (
                  <div className="iframe-fallback">
                    <iframe
                      title="Atendimento Virtual"
                      src={chatUrl}
                      allow="camera; microphone; autoplay; clipboard-read; clipboard-write"
                      sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-modals allow-downloads"
                    />
                  </div>
                ) : (
                  <>
                    {isBotLoading && (
                      <div className="typebot-loader" role="status" aria-live="polite">
                        <div className="spinner" />
                        <p>Carregando atendimento...</p>
                      </div>
                    )}
                    <div id={containerId} data-ready={botReady} aria-busy={isBotLoading} />
                  </>
                )}
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}

function PhoneGate({ onVerified }) {
  const [phone, setPhone] = useState('');
  const [codeSent, setCodeSent] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const sendCode = async () => {
    if (!phone || phone.length < 10) {
      setError('Informe um telefone válido com DDD.');
      return;
    }
    setError('');
    setSending(true);
    const formatted = phone.startsWith('+') ? phone : `+55${phone}`;
    try {
      let verifier = window.recaptchaVerifier;
      if (!verifier) {
        verifier = new RecaptchaVerifier(auth, 'recaptcha-container', { size: 'invisible' });
        window.recaptchaVerifier = verifier;
        await verifier.render();
      }
      const confirmation = await signInWithPhoneNumber(auth, formatted, verifier);
      setConfirmationResult(confirmation);
      setCodeSent(true);
    } catch (err) {
      console.error(err);
      setError(
        err?.message ||
          'Não foi possível enviar o SMS agora. Confira o número ou tente novamente em instantes.'
      );
    } finally {
      setSending(false);
    }
  };

  const verifyCode = async () => {
    if (!confirmationResult) {
      setError('Envie o código primeiro.');
      return;
    }
    if (!code.trim()) {
      setError('Digite o código recebido por SMS.');
      return;
    }
    setVerifying(true);
    setError('');
    try {
      await confirmationResult.confirm(code.trim());
      localStorage.setItem('wc_phone_verified', 'true');
      onVerified(true);
    } catch (err) {
      console.error(err);
      setError('Código inválido ou expirado. Peça um novo código.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="section-card gate-card">
      <div>
        <p className="eyebrow">Segurança</p>
        <h3>Confirme seu telefone</h3>
        <p className="muted">
         <b>Valide seu celular e tenha acesso completo à WebCash.</b> 
         
        </p>
        <p className="muted">
          Simule, acompanhe e fale com a gente com segurança e rapidez.
        </p>
      </div>
      <div className="gate-fields">
        <label htmlFor="phone">Telefone (DDD + número)</label>
        <input
          id="phone"
          type="tel"
          value={phone}
          placeholder="11999998888"
          onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
        />
        <button type="button" className="ghost-btn" onClick={sendCode} disabled={sending}>
          {sending ? 'Enviando...' : 'Enviar código por SMS'}
        </button>

        {codeSent && (
          <>
            <label htmlFor="code">Código recebido</label>
            <input
              id="code"
              type="text"
              value={code}
              placeholder="123456"
              onChange={(e) => setCode(e.target.value)}
            />
            <button type="button" className="ghost-btn primary" onClick={verifyCode}>
              {verifying ? 'Validando...' : 'Validar acesso'}
            </button>
          </>
        )}
        {error && <p className="error">{error}</p>}
        <div id="recaptcha-container" className="recaptcha-slot" />
      </div>
    </div>
  );
}

function Home({ onNavigate }) {
  return (
    <div className="section-card">
      <div className="hero">
        <div>
          <p className="eyebrow">WebCash Digital</p>
          <h1>
            Credito sem burocracia
            <span>Descomplicamos o crédito para simplificar a sua vida financeira.</span>
          </h1>
          <p className="muted">
            Simule, acompanhe e fale com a equipe WebCash em um so lugar. Feito para clientes e
            futuros clientes que valorizam seguranca e rapidez.
          </p>
        </div>
        <div className="hero-chip">
          <p>Taxa a partir de 4,5% a.m.</p>
          <strong>Confianca + transparencia</strong>
        </div>
      </div>
      <div className="quick-actions">
        <button
          type="button"
          className="quick-card"
          onClick={() => onNavigate?.('simulate')}
        >
          <span className="badge">Novo</span>
          <h3>Simule agora</h3>
          <p className="muted">Compare parcelas e prazos em segundos.</p>
        </button>
        <button
          type="button"
          className="quick-card"
          onClick={() => onNavigate?.('requests')}
        >
          <span className="badge secondary">Status</span>
          <h3>Acompanhe solicitacoes</h3>
          <p className="muted">Veja liberacao, prazo e status em tempo real.</p>
        </button>
        <button
          type="button"
          className="quick-card"
          onClick={() => onNavigate?.('support')}
        >
          <span className="badge neutral">Ajuda</span>
          <h3>Atendimento humano</h3>
          <p className="muted">Equipe pronta para tirar duvidas no chat.</p>
        </button>
        <button
          type="button"
          className="quick-card"
          onClick={() => onNavigate?.('faq')}
        >
          <span className="badge neutral">FAQ</span>
          <h3>Dúvidas frequentes</h3>
          <p className="muted">Veja perguntas e respostas sobre crédito e WebCash.</p>
        </button>
      </div>
    </div>
  );
}

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [verified, setVerified] = useState(false);
  const [phoneUser, setPhoneUser] = useState('');
  const [profileData, setProfileData] = useState(null);
  const [requestsData, setRequestsData] = useState([]);
  const [correspondentData, setCorrespondentData] = useState(null);
  const contractContainerId = 'contractbot-container';
  const [contractOverlay, setContractOverlay] = useState(false);
  const [contractBotReady, setContractBotReady] = useState(false);
  const [contractBotError, setContractBotError] = useState(false);
  const [contractBotLoaded, setContractBotLoaded] = useState(false);
  const isContractBotLoading = contractOverlay && !contractBotError && !contractBotLoaded;
  const correspondent = useMemo(() => {
    const path = (window.location && window.location.pathname) || '';
    const [firstSegment = ''] = path.split('/').filter(Boolean);
    return decodeURIComponent(firstSegment || '');
  }, []);
  const contractUrl = useMemo(() => {
    const phone = encodeURIComponent(phoneUser || '');
    const host = encodeURIComponent(window?.location?.host || '');
    const idCorr = encodeURIComponent(
      correspondentData?.consultor.id || ''
    );
    const haccessParam = encodeURIComponent(profileData?.haccess || '');
    return `https://kira.viabillize.com.br/contratar-pwaconsig?phone=${phone}&sistema=${host}&idcorrespondente=${idCorr}&haccess=${haccessParam}`;
  }, [phoneUser, correspondentData, profileData]);

  useEffect(() => {
    setVerified(localStorage.getItem('wc_phone_verified') === 'true');
  }, []);

  useEffect(() => {
    const ensureScript = () => {
      if (window.Typebot?.initStandard) {
        setContractBotReady(true);
        return;
      }
      let script = document.getElementById('typebot-module');
      const handleLoad = () => setContractBotReady(true);
      const handleError = (error) => {
        console.error('Erro ao carregar o Typebot', error);
        setContractBotError(true);
      };
      if (!script) {
        script = document.createElement('script');
        script.id = 'typebot-module';
        script.type = 'module';
        script.innerHTML = `
          import Typebot from 'https://cdn.jsdelivr.net/npm/@typebot.io/js@0.3.27/dist/web.js';
          window.Typebot = Typebot;
        `;
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
        document.body.appendChild(script);
      } else {
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
      }
      return () => {
        script?.removeEventListener('load', handleLoad);
        script?.removeEventListener('error', handleError);
      };
    };
    const cleanup = ensureScript();
    return cleanup;
  }, []);

  useEffect(() => {
    if (!contractOverlay || !contractBotReady || contractBotError) return;
    const container = document.getElementById(contractContainerId);
    if (!container || container.dataset.typebotLoaded) return;
    if (!window.Typebot?.initStandard) return;
    try {
      window.Typebot.initStandard({
        typebot: 'contratar-pwaconsig',
        apiHost: 'https://kira.viabillize.com.br',
        element: `#${contractContainerId}`,
        url: contractUrl,
      });
      container.dataset.typebotLoaded = 'true';
      setContractBotLoaded(true);
    } catch (error) {
      console.error('Erro ao iniciar o Typebot de contratacao (global)', error);
      setContractBotError(true);
    }
  }, [contractOverlay, contractBotReady, contractBotError, contractUrl, contractContainerId]);

  useEffect(() => {
    if (!contractOverlay || contractBotError || contractBotLoaded) return;
    const timer = setTimeout(() => {
      const container = document.getElementById(contractContainerId);
      if (container && container.dataset.typebotLoaded) {
        setContractBotLoaded(true);
        return;
      }
      setContractBotError(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [contractOverlay, contractBotError, contractBotLoaded, contractContainerId]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && user.phoneNumber) {
        setPhoneUser(user.phoneNumber);
        setVerified(true);
        localStorage.setItem('wc_phone_verified', 'true');
      } else {
        setPhoneUser('');
      }
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const applyData = (data) => {
        window.__USER_PROFILE = data;
        setProfileData(data?.user || null);
        setRequestsData(data?.requests || []);
        setCorrespondentData(data?.correspondente || null);
      };

      try {
        const token = await currentUser.getIdToken();
        const res = await fetch('/api/getUserProfile', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            phone: phoneUser || undefined,
            correspondent: correspondent || '',
          }),
        });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const data = await res.json();
        applyData(data);
        return;
      } catch (err) {
        console.warn('Fetch relative API falhou, tentando callable', err);
      }

      try {
        const functions = getFunctions(app);
        const fn = httpsCallable(functions, 'getUserProfile');
        const res = await fn({
          phone: phoneUser || undefined,
          correspondent: correspondent || '',
        });
        applyData(res.data);
      } catch (err) {
        console.error('Erro ao buscar perfil', err);
      }
    };

    const handleRefresh = () => {
      fetchProfile();
    };

    const handleGoSimulate = () => setActiveTab('simulate');

    if (verified) {
      fetchProfile();
      window.addEventListener('refresh-requests', handleRefresh);
      window.addEventListener('go-simulate', handleGoSimulate);
    }

    return () => {
      window.removeEventListener('refresh-requests', handleRefresh);
      window.removeEventListener('go-simulate', handleGoSimulate);
    };
  }, [verified, phoneUser, correspondent]);

  const panels = {
    home: <Home onNavigate={setActiveTab} />,
    simulate: (
      <Simulator
        phoneUser={phoneUser}
        correspondent={correspondentData}
        haccess={profileData?.haccess}
        onOpenContract={() => setContractOverlay(true)}
      />
    ),
    requests: <Requests items={requestsData} profile={profileData} />,
    faq: <Faq />,
    support: (
      <Support
        correspondent={correspondentData}
        phoneUser={phoneUser}
        haccess={profileData?.haccess}
        onOpenContract={() => setContractOverlay(true)}
      />
    ),
  };

  return (
    <div className="app-shell">
      <div className="background-glow" />
      <header className="topbar">
        <div className="topbar-content">
          {/* <p className="eyebrow">WebCash Digital</p> */}
          {/* <h2>Bem-vindo(a) de volta</h2> */}
        </div>
        <div className="user-actions">
          {verified ? (
            <div className="user-chip">
              <span role="img" aria-label="sparkles">
                ✨
              </span>
              <div className="user-chip-text">
                {/* <strong>Conectado</strong> */}
                <span className="muted">{phoneUser || 'Número verificado'}</span>
              </div>
              <button
                type="button"
                className="logout-link"
                onClick={() => {
                  const ok = window.confirm(
                    'Deseja desconectar o número e sair da sessão?'
                  );
                  if (ok) {
                    auth.signOut().finally(() => {
                      localStorage.removeItem('wc_phone_verified');
                      setVerified(false);
                      setPhoneUser('');
                    });
                  }
                }}
              >
                Sair
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="connect-btn"
              onClick={() => {
                setActiveTab('simulate');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Conectar
            </button>
          )}
        </div>
      </header>

      <main className="main-content">
        {Object.entries(panels).map(([id, content]) => (
          <div
            key={id}
            className={`tab-panel ${activeTab === id ? 'active' : ''}`}
            aria-hidden={activeTab !== id}
          >
            {id !== 'home' && !verified ? <PhoneGate onVerified={setVerified} /> : content}
          </div>
        ))}
      </main>

      <div
        className={`typebot-overlay ${contractOverlay ? 'open' : 'hidden'}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!contractOverlay}
      >
        <div className="typebot-modal">
          <div className="typebot-bar">
            <div>
              <p className="eyebrow">AUTOCONTRATAÇÃO</p>
              <strong>Contratação em tempo real</strong>
            </div>
            <button
              type="button"
              className="close-btn"
              onClick={() => setContractOverlay(false)}
            >
              Fechar
            </button>
          </div>
          <div className="typebot-frame">
            {contractBotError ? (
              <div className="iframe-fallback">
                <iframe
                  id="typebotFrame1"
                  title="Contratacao PWAC"
                  src={contractUrl}
                  allow="camera; microphone; autoplay; clipboard-read; clipboard-write;geolocation"
                  sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-modals allow-downloads"
                />
              </div>
            ) : (
              <>
                {isContractBotLoading && (
                  <div className="typebot-loader" role="status" aria-live="polite">
                    <div className="spinner" />
                    <p>Iniciando ...</p>
                  </div>
                )}
                <div
                  id={contractContainerId}
                  data-ready={contractBotReady}
                  aria-busy={isContractBotLoading}
                />
              </>
            )}
          </div>
        </div>
      </div>

      <nav className="tabbar" aria-label="Navegacao principal">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => {
              setActiveTab(tab.id);
              if (tab.id === 'requests' && verified) {
                const evt = new CustomEvent('refresh-requests');
                window.dispatchEvent(evt);
              }
            }}
          >
            <span className="tab-icon">{tab.icon()}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default App;
